module.exports = __webpack_public_path__ + "static/media/C_S02.19423420.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/C_S02.png
// module id = 101
// module chunks = 0